import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { baseUrl } from "constant";
import {
    IContractCheckResponseType,
    IContractCheckType,
    IContractHistoryResponseType, IContractIncentivesResponseType, IEmployeeContractListRequest, IEmployeeContractListResponse,
    IEmployeeDetailsRequestType, IEmployeeDetailsTypeResponse, IEmployeeInfoTypeResponse,
    IPendingEmployeeRequestType,
    IPendingEmployeeResponseType,
    IRequestType, IResponseType
} from "./type";
import { RootState } from "store/store";
import { getAuthToken } from "utils/getAuthToken";
import { handlingErrorResponse } from "utils/HandlingErrorResponse";
import {
    EmployeeContractEndpointConst, deleteContractByIdUrl, getContractHistoryUrl,
    getCurrentContractDetailByIdUrl, getEmployeeDetailsByEmployeeCodeUrl, getInActiveContractHistoryUrl, getIncentivesDetailByCodeUrl,
    getPendingEmployeeLeaveUrl,
    getPendingEmployeeOverTimeUrl,
    getPendingEmployeeSalaryUrl
} from "./const";


export const EmployeeContractApi = createApi({
    reducerPath: 'employeeContractApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['EmployeeContract'],
    endpoints: (builder) => ({
        EmployeeContractList: builder.mutation<IEmployeeContractListResponse, IEmployeeContractListRequest>({
            query: userReq => ({
                url: EmployeeContractEndpointConst.employeeContractList,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'EmployeeContract', id: 'EmployeeContractList' }],
        }),
        GetCurrentContractDetails: builder.query<IResponseType, IRequestType>({
            query: (params) => getCurrentContractDetailByIdUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'EmployeeContract', id: 'EmployeeContractList' }]
        }),
        GetEmployeeInfo: builder.query<IEmployeeInfoTypeResponse, void>({
            query: () => EmployeeContractEndpointConst.employeeInfo,
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'EmployeeContract', id: 'EmployeeName' }]
        }),
        AddContractInfo: builder.mutation<IResponseType, FormData>({
            query: userReq => ({
                url: EmployeeContractEndpointConst.addContractInfo,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'EmployeeContract', id: 'AddContractInfo' }],
        }),
        GetEmployeeDetailsByCode: builder.query<IEmployeeDetailsTypeResponse, IEmployeeDetailsRequestType>({
            query: (params) => getEmployeeDetailsByEmployeeCodeUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'EmployeeContract', id: 'EmployeeDetails' }]
        }),
        GetContractHistoryByCode: builder.query<IContractHistoryResponseType, IEmployeeDetailsRequestType>({
            query: (params) => getContractHistoryUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'EmployeeContract', id: 'AddContractInfo' }]
        }),
        GetInActiveContractHistoryByCode: builder.query<IContractHistoryResponseType, IEmployeeDetailsRequestType>({
            query: (params) => getInActiveContractHistoryUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'EmployeeContract', id: 'AddContractInfo' }]
        }),
        DeleteContract: builder.mutation<IResponseType, IRequestType>({
            query: userReq => ({
                url: deleteContractByIdUrl(userReq),
                method: 'DELETE',
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'EmployeeContract', id: 'EmployeeContractList' }],
        }),
        CheckContractRunning: builder.mutation<IContractCheckResponseType, IContractCheckType>({
            query: userReq => ({
                url: EmployeeContractEndpointConst.checkRunningContract,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'EmployeeContract', id: 'CheckContractRunning' }],
        }),
        GetContractIncentivesByCode: builder.query<IContractIncentivesResponseType, IEmployeeDetailsRequestType>({
            query: (params) => getIncentivesDetailByCodeUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'EmployeeContract', id: 'AddContractInfo' }]
        }),
        GetPendingEmployeeLeaveByCode: builder.query<IPendingEmployeeResponseType, IPendingEmployeeRequestType>({
            query: (params) => getPendingEmployeeLeaveUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'EmployeeContract', id: 'AddContractInfo' }]
        }),
        GetPendingEmployeeOvertimeByCode: builder.query<IPendingEmployeeResponseType, IPendingEmployeeRequestType>({
            query: (params) => getPendingEmployeeOverTimeUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'EmployeeContract', id: 'AddContractInfo' }]
        }),
        GetPendingEmployeeSalaryByCode: builder.query<IPendingEmployeeResponseType, IPendingEmployeeRequestType>({
            query: (params) => getPendingEmployeeSalaryUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'EmployeeContract', id: 'AddContractInfo' }]
        }),
    })
})